import { Component, Inject, OnInit, inject } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, InteractionType, AccountInfo, BrowserUtils } from '@azure/msal-browser';
import { Subject, Subscription, filter, takeUntil } from 'rxjs';
import { Models } from 'purecloud-platform-client-v2';
import { ToastService } from '../toast/toast.service';
import { NavigationEnd, Router } from '@angular/router';
import { AppInsightsService } from '../app-insights.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { GenesysCloudService } from '../genesys-cloud.service';
import { Location } from '@angular/common';
import { AppConfigService } from '../app-config.service';
import { jwtDecode } from 'jwt-decode';
import { LoginService } from './login.service';
@Component({
  selector: 'app-login-action',
  templateUrl: './login-action.component.html',
  styleUrl: './login-action.component.scss'
})
export class LoginActionComponent implements OnInit {
  toastService = inject(ToastService);
  genesysUserSubscription: Subscription | undefined;
  loginDisplay = false;
  isIframe = false;
  account: AccountInfo | null = null;
  private readonly _destroying$ = new Subject<void>();
  userDetails: Models.UserMe | undefined;
  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService, private aiService: AppInsightsService, private router: Router,
    private oAuthService: OAuthService, private genesysCloudService: GenesysCloudService,
    public location: Location, private appConfigService: AppConfigService,
    private loginService: LoginService) {
    this.oAuthService.configure(this.appConfigService.genesysAuthConfig);
    this.isIframe = BrowserUtils.isInIframe();
  }

  ngOnInit() {
    this.initializeAIService();
    this.subscribeToRouterEvents();
    this.subscribeToAuthService();
    this.subscribeGenesysUserDetails();
  }

  private initializeAIService() {
    this.aiService.init();
  }

  private subscribeToRouterEvents() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.aiService.logPageView('PageView', event.urlAfterRedirects);
      }
    });
  }

  private subscribeToAuthService() {
    this.isIframe = BrowserUtils.isInIframe();
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    this.authService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result?.state) this.router.navigateByUrl(result.state)
      },
      error: (error) => console.error(error)
    });
  }

  private subscribeGenesysUserDetails() {
    this.genesysUserSubscription = this.genesysCloudService.userDetails$.subscribe(message => {
      this.userDetails = message
    });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      const accessToken = this.loginService.getMicrosoftAccessToken();
      accessToken.then(token => {
        if (token) {
          const decodedToken: any = jwtDecode(token);
          if (decodedToken['roles']) {
            const roles = decodedToken['roles'].map((role: string) => role.toLowerCase());
            const isLeadUserInterface = roles.includes('AdmissionLead'.toLowerCase());
            const isAdmissionCompliance = roles.includes('AdmissionCompliance'.toLowerCase());
            localStorage.setItem('isLeadUserInterface', isLeadUserInterface.toString());
            localStorage.setItem('isAdmissionCompliance', isAdmissionCompliance.toString());
          }
        }
      }).catch(error => console.error(error));
    }
  }

  logout() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.genesysUserSubscription?.unsubscribe();
  }
}
